/** Temporary flag for design system gallery — remove with gallery routes after audit. */
export const isDesignGalleryEnabled =
  String(process.env.REACT_APP_ENABLE_DESIGN_GALLERY) === 'true' ||
  String(process.env.REACT_APP_ENABLE_BUTTON_GALLERY) === 'true';

/** @deprecated Use isDesignGalleryEnabled */
export const isButtonGalleryEnabled = isDesignGalleryEnabled;
